export default {
  group: (state) => state.group,
  groups: (state) => state.groups
}



// WEBPACK FOOTER //
// ./src/store/modules/group/getters.js